<!-- Table -->
@if ({
  row: columnData() | async,
  column: columns() | async,
  totalrecord: totalRecords() | async,
  select: selectable() | async
  }; as $) {
  <p-table
    [value]="$.row"
    [selectionMode]="selectionMode()"
    scrollHeight="flex"
    scrollDirection="both"
    (onRowSelect)="selectedRow($event, true)"
    (onRowUnselect)="selectedRow($event, false)"
    (onHeaderCheckboxToggle)="SelectAllRow($event)"
    styleClass=""
    responsiveLayout="scroll"
    [rowGroupMode]="groupMode()"
    [groupRowsBy]="groupRows()"
    [lazy]="true"
    [rows]="pageSize"
    [(first)]="first"
    [paginator]="paginator()"
    [totalRecords]="$.totalrecord.totalItems"
    [showCurrentPageReport]="true"
    (onPage)="goToNextPage($event)"
    [loading]="loading()"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [rowsPerPageOptions]="[10, 25, 50,100]"
    [(selection)]="selectedRowData"
    [resizableColumns]="resizableColumns()"
    [columnResizeMode]="columnResizeMode()"
    [attr.aria-label]="gridName() + '-data-grid'"
    >
    @if (showHeader()) {
      <ng-template pTemplate="header">
        <tr class="text-xs">
          @if ($.select) {
            <th class="text-600" [ngClass]="headerClasses()" aria-label="select-all-column">
              <!-- <p-checkbox checkboxIcon="fa fa-check" name="groupname" value="val1" label=""></p-checkbox> -->
              <p-tableHeaderCheckbox aria-label="select-all-checkbox" />
            </th>
          }
          @for (col of $.column; track $index; let i = $index) {
            @if (col && col.translate) {
              <th  class="text-600 surface-100 font-bold border-none white-space-nowrap" [ngClass]="headerClasses()" [attr.aria-label]="'column-header-' + i" pResizableColumn>
                {{ col.title }}
              </th>
            } @else {
              <th class="text-600 surface-100 font-bold border-none white-space-nowrap" [ngClass]="headerClasses()" [attr.aria-label]="'column-header-' + i" pResizableColumn>
                {{ col.title }}
              </th>
            }
          }
        </tr>
      </ng-template>
    }
    <ng-template
      pTemplate="body"
      let-rowgroup="rowgroup"
      let-rowspan="rowspan"
      let-rowIndex="rowIndex"
      let-data
      >
      @if (selectionMode() === 'single') {
        <tr class="text-sm hover:surface-200 cursor-pointer" [ngClass]="{'opacity-60': !isRowSelectable(data)}" [pSelectableRow]="data" [attr.aria-label]="gridName() + '-row'"
        (click)="onRowClickHandler($event, data, rowIndex)">
          @if ($.select) {
            <td class="py-2 white-space-nowrap">
              <p-tableCheckbox [value]="setCheckBoxValue(rowIndex, data)"
                [disabled]="!isRowSelectable(data)"
                [attr.aria-label]="'select-row-' + rowIndex"
               />
            </td>
          }
          @if (!groupMode()) {
            @for (col of $.column; track $index; let i = $index) {
              <td class="py-2 white-space-nowrap" [ngClass]="col.classes" [attr.aria-label]="'cell-' + rowIndex + '-' + i">
                @if (col.type === 'default') {
                  {{ data[col.dataProperty] }}
                }
                <!-- Allow HTML type here to render  -->
                @if (col.type === 'component') {
                  <app-grid-cell [cell]="setAsObserVable(col)"
                    [cellData]="setAsObserVable(data)"
                    (actionEvent)="onActionEvent($event)"
                    [allSelection]="isAllSelected"
                    [rowIndex]="rowIndex"
                    [selectedRows]="selectedRows"
                    [attr.aria-label]="'component-cell-' + rowIndex + '-' + i"
                   />
                }
              </td>
            }
          }
          @if (groupMode()) {
            @for (col of $.column; track $index; let i = $index) {
              @if (i !== 0) {
                <td
                  class="py-2 white-space-nowrap"
                  [ngClass]="col.classes"
                  [attr.aria-label]="'group-cell-' + rowIndex + '-' + i"
                  >
                  @if (col.type === 'default') {
                    {{ data[col.dataProperty] }}
                  }
                  @if (col.type === 'component') {
                    <app-grid-cell [cell]="setAsObserVable(col)"
                      [cellData]="setAsObserVable(data)"
                      (onAction)="onActionEvent($event)"
                      [attr.aria-label]="'group-component-cell-' + rowIndex + '-' + i"
                     />
                  }
                </td>
              } @else {
                @if (rowgroup) {
                  <td
                    class="py-2 white-space-nowrap surface-0"
                    [ngClass]="col.classes"
                    [attr.rowspan]="rowgroup ? rowspan : null"
                    [attr.aria-label]="'group-header-cell-' + rowIndex"
                    >
                    @if (col.type === 'default') {
                      {{
                      !isEmptyAndNull(data[col.dataProperty])
                      ? data[col.dataProperty]
                      : ''
                      }}
                    }
                    @if (col.type === 'component') {
                      <app-grid-cell [cell]="setAsObserVable(col)"
                        [cellData]="setAsObserVable(data)"
                        (onAction)="onActionEvent($event)"
                        [allSelection]="isAllSelected"
                        [attr.aria-label]="'group-header-component-cell-' + rowIndex"
                       />
                    }
                  </td>
                }
              }
            }
          }
        </tr>
      }
      @if (selectionMode() !== 'single') {
        <tr class="text-sm hover:surface-200 cursor-pointer"
          [ngClass]="{'opacity-60': !isRowSelectable(data)}"
          [attr.aria-label]="gridName() + '-row'"
          (click)="onRowClickHandler($event, data, rowIndex)">
          @if ($.select) {
            <td class="py-2 white-space-nowrap">
              <p-tableCheckbox [value]="setCheckBoxValue(rowIndex, data)"
                [disabled]="!isRowSelectable(data)"
                [attr.aria-label]="'select-row-' + rowIndex"
               />
            </td>
          }
          @if (!groupMode()) {
            @for (col of $.column; track $index; let i = $index) {
              <td class="py-2 white-space-nowrap" [ngClass]="col.classes" [attr.aria-label]="'cell-' + rowIndex + '-' + i">
                @if (col.type === 'default') {
                  {{ data[col.dataProperty] }}
                }
                <!-- Allow HTML type here to render  -->
                @if (col.type === 'component') {
                  <app-grid-cell [cell]="setAsObserVable(col)"
                    [cellData]="setAsObserVable(data)"
                    (actionEvent)="onActionEvent($event)"
                    [allSelection]="isAllSelected"
                    [rowIndex]="rowIndex"
                    [selectedRows]="selectedRows"
                    [attr.aria-label]="'component-cell-' + rowIndex + '-' + i"
                   />
                }
              </td>
            }
          }
          @if (groupMode()) {
            @for (col of $.column; track $index; let i = $index) {
              @if (i !== 0) {
                <td
                  class="py-2 white-space-nowrap"
                  [ngClass]="col.classes"
                  [attr.aria-label]="'group-cell-' + rowIndex + '-' + i"
                  >
                  @if (col.type === 'default') {
                    {{ data[col.dataProperty] }}
                  }
                  @if (col.type === 'component') {
                    <app-grid-cell [cell]="setAsObserVable(col)"
                      [cellData]="setAsObserVable(data)"
                      (onAction)="onActionEvent($event)"
                      [attr.aria-label]="'group-component-cell-' + rowIndex + '-' + i"
                     />
                  }
                </td>
              } @else {
                @if (rowgroup) {
                  <td
                    class="py-2 white-space-nowrap surface-0"
                    [ngClass]="col.classes"
                    [attr.rowspan]="rowgroup ? rowspan : null"
                    [attr.aria-label]="'group-header-cell-' + rowIndex"
                    >
                    @if (col.type === 'default') {
                      {{
                      !isEmptyAndNull(data[col.dataProperty])
                      ? data[col.dataProperty]
                      : ''
                      }}
                    }
                    @if (col.type === 'component') {
                      <app-grid-cell [cell]="setAsObserVable(col)"
                        [cellData]="setAsObserVable(data)"
                        (onAction)="onActionEvent($event)"
                        [allSelection]="isAllSelected"
                        [attr.aria-label]="'group-header-component-cell-' + rowIndex"
                       />
                    }
                  </td>
                }
              }
            }
          }
        </tr>
      }
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <td [attr.colspan]="$.column.length + 1" [class]="EmptyStateClass()" aria-label="empty-state">
        <empty-state-container (onAction)="emptyAction($event)"
          [emptyState]="EmptyState()"
         />
      </td>
    </ng-template>
    <ng-template pTemplate="loadingbody" let-columns="columns">
      @if (columns && columns.length > 0) {
        <tr height="2rem" aria-label="loading-row">
          @for (col of columns; track $index; let i = $index) {
            <td [attr.aria-label]="'loading-cell-' + i">
              <p-skeleton animation="wave" width="100%" height="2rem" [attr.aria-label]="'skeleton-loader-' + i" />
            </td>
          }
        </tr>
      } @else {
        <tr height="2rem" aria-label="skeleton-row">
          @for (i of [0,1,2,3,4,5]; track i) {
            <td [attr.aria-label]="'skeleton-cell-' + i">
              <p-skeleton [attr.aria-label]="'skeleton-loader-' + i" />
            </td>
          }
        </tr>
        @for (row of [0,1,2,3,4,5,6]; track row) {
          <tr [attr.aria-label]="'skeleton-row-' + row">
            @for (col of [0,1,2,3,4,5]; track col) {
              <td [attr.aria-label]="'skeleton-cell-' + row + '-' + col">
                <p-skeleton [attr.aria-label]="'skeleton-loader-' + row + '-' + col" />
              </td>
            }
          </tr>
        }
      }
    </ng-template>
  </p-table>
}

<!-- </ng-container> -->

<!-- </ng-container> -->

<p-dialog
  [visible]="showCalendar"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '1025px': '100vw', '640px': '100vw' }"
  [style]="{ width: '29vw' }"
  styleClass="no-header-modal no-overflow-content"
  aria-label="calendar-dialog"
  >
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <p-datepicker styleClass="w-full"
      [(ngModel)]="calendarInput"
      [inline]="true"
      [showWeek]="true"
      (onSelect)="showCalendar = false"
      aria-label="date-picker"
     />
  </ng-template>
</p-dialog>
